// Lodash
import _join from 'lodash/join';
import _compact from 'lodash/compact';

var joinTruthyValues = function joinTruthyValues(values, separator) {
  return _join(_compact(values), separator);
};

export default joinTruthyValues;